import React from "react"

export const Message: React.FC<{ message: string | undefined }> = ({ message }) => {
    return (
        <>
            <hr />
            <p>{message}</p>
        </>
    )
}
